module.exports = __webpack_public_path__ + "img/download-button.d4f49edc.svg";